import { handleActions } from 'redux-actions';

import localize from '../../../localization/container';
import * as apiActions from '../actions';

const defaultState = {
  error: '',
  activeUser:{},
};

export const activeUser = handleActions(
  {
    [apiActions.activeUserCharSuccess]: (state, action) => {
        return {
          ...state,
          activeUser: action.payload
        };
      },
   

    [apiActions.activeUserCharFail]: (state, action) => ({
      ...state,
      error: action.payload
  }),
 

    
  },
  defaultState
);
